import { render, staticRenderFns } from "./MemberMenuCount.vue?vue&type=template&id=2436bf40&scoped=true&"
import script from "./MemberMenuCount.vue?vue&type=script&lang=js&"
export * from "./MemberMenuCount.vue?vue&type=script&lang=js&"
import style0 from "./MemberMenuCount.vue?vue&type=style&index=0&id=2436bf40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2436bf40",
  null
  
)

export default component.exports